package com.gsb.vyapar.bhagya.presentation.admin.view

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.admin.util.getAllMBusinessUserUI
import com.gsb.vyapar.bhagya.presentation.common.expandablelist.ExpandableList
import com.gsb.vyapar.bhagya.presentation.common.expandablelist.SectionData
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar

@Composable
fun ReviewView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar("Review View")
            Column(Modifier.fillMaxSize()) {
                ExpandableList(uiState, onTriggerEvent, uiState.adminUiState.userBusinessMap.map { SectionData(it.key, it.value) })
            }
        }
    }
    LaunchedEffect(Unit) {
        getAllMBusinessUserUI()
    }
}